var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"index-wrapper","direction":"vertical"}},[_c('pcFromHead',{attrs:{"logoSrc":_vm.logoSrc,"sysName":_vm.sysName,"menuData":_vm.menuData,"acColor":_vm.acColor,"bgColor":_vm.bgColor}}),_c('el-main',{attrs:{"id":"index-main"}},[_c('section',{staticClass:"elMainSe",style:({
        height: _vm.$route.meta.showFoot
          ? 'calc(100vh - 100px)'
          : 'calc(100vh - 80px)',
        width: this.offsetWidth > 1488 ? 'calc(100% - 100px)' : '100%'
      })},[_c('router-view')],1)]),(_vm.$route.meta.showFoot)?_c('foot',{attrs:{"cpString":_vm.cpString}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }